import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import MediaPost from "./media/MediaPost";

import { isMobile } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  addPostCommunaute,
  uploadPhotos,
  deleteMedia,
  uploadVideo,
  attachFiles,
  attachVideo,
} from "./Communaute.duck";
import classNames from "classnames";
import { openSnackBar } from "../../../../reducers";
import _ from "lodash";
import { css } from "@emotion/core";
import DotLoader from "react-spinners/DotLoader";
import imgWhite from "../../../../styles/img/media-blue.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";

const style = {
  height: 30,
  border: "1px solid green",
  margin: 6,
  padding: 8,
};
class ModalPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array: [],
      openMediaPost: false,
      favMedia: false,
      snackBarStatus: false,
      postDescription: "",
      width: window.innerWidth,
      completed: false,
      hasMore: true,
      items: Array.from({ length: 1 }),
      height: 0,
      styleFadeIn: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();
    this.openMediaPost = this.openMediaPost.bind(this);
    this.onCloseModalePhoto = this.onCloseModalePhoto.bind(this);
    this.handleChangeDescription = this.handleChangeDescription.bind(this);
    this.attachFile = this.attachFile.bind(this);
    this.toMega = this.toMega.bind(this);
    this.fetchMoreData = this.fetchMoreData.bind(this);
    this.deleteMedia = this.deleteMedia.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  deleteMedia(dataPost, element) {
    this.props.deleteMedia(dataPost, element);
  }
  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  onCloseModalePhoto() {
    this.setState({
      openMediaPost: false,
    });
  }
  openMediaPost() {
    this.setState({
      openMediaPost: true,
    });
  }
  handleChangeDescription(event) {
    let value = event.target.value;
    this.setState({ postDescription: value });
  }
  handleChange(event) {
    event.preventDefault();
    this.setState({
      array: [...this.state.array, this.fileInput.current.files[0].name],
    });
  }
  handleSubmit(event) {
    event.preventDefault();
    let tok = localStorage.getItem("token");
    if (
      this.props.dataPost.files.length < 1 &&
      _.isEmpty(this.state.postDescription)
    ) {
      let name = "";
      let message = "Ajouter un message, une photo ou une vidéo";
      this.props.openSnackBar(name, message);
    } else {
      if (this.props.dataPost.type === "PHOTOS") {
        const data = {
          description: this.state.postDescription,
          dataPost: this.props.dataPost,
        };
        this.props.uploadPhotos(tok, data);
      } else if (this.props.dataPost.type === "VIDEO") {
        let data = {
          video: this.props.dataPost.files,
          description: this.state.postDescription,
        };
        this.props.uploadVideo(tok, data);
      } else {
        this.props.addPostCommunaute(tok, this.state.postDescription);
        this.setState({
          styleFadeIn: false,
        });
        setTimeout(() => {
          this.props.closeModalPost();
        }, 400);
      }
    }
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  componentDidUpdate(prevProps) {
    let items = this.props.dataPost.files ? this.props.dataPost.files : [];
    if (prevProps.dataPost.files.length !== this.props.dataPost.files.length) {
      this.setState({
        items: items,
      });
      if (!this.props.loading && prevProps.loading && !this.props.error) {
        this.props.closeModalPost();
      }
    }
  }
  attachFile(e) {
    let valid = false;
    let files = Object.values(e.target.files);
    //comment
    let videos = files.filter((element) => {
      return isVideo(element.name) || element.type === "video/quicktime";
    });
    let photoSizeUp = files.filter((element) => {
      let sizeInMB = (element.size / (1024 * 1024)).toFixed(0);
      return (
        isImage(element.name) &&
        sizeInMB > 5 &&
        element.type !== "video/quicktime"
      );
    });
    let photoSizeDown = files.filter((element) => {
      let sizeInMB = (element.size / (1024 * 1024)).toFixed(0);
      return element.type !== "video/mp4" && sizeInMB <= 5;
    });

    if (photoSizeUp.length) {
      let name = "";
      let message = "Impossible d'ajouter des photos supérieur à 5 méga";
      this.props.openSnackBar(name, message);
    }
    if (this.props.dataPost.files.length + e.target.files.length > 30) {
      valid = false;
      let name = "";
      let message = "Impossible d'ajouter plus que 30 image";
      this.props.openSnackBar(name, message);
    }
    if (videos.length > 1) {
      valid = false;
      let name = "";
      let message = "Impossible d'ajouter plus qu'un media de type video";
      this.props.openSnackBar(name, message);
    }
    if (
      (videos.length && e.target.files.length > 1) ||
      (videos.length && this.props.dataPost.files.length > 0)
    ) {
      valid = false;
      let name = "";
      let message = "Impossible de mixer les photos et les vidéo";
      this.props.openSnackBar(name, message);
    }
    if (videos.length === 1) {
      let size = this.toMega(videos[0].size);
      size = size.split(" ", 1);
      if (parseFloat(size) > 25) {
        valid = false;
        let name = "";
        let message =
          "Impossible d'ajouter un vidéo de taille supérieur à 25 Méga";
        this.props.openSnackBar(name, message);
      } else {
        this.props.attachVideo(files[0]);
        if (this.state.width > 992) {
          this.props.onCloseModalePhoto();
        }
      }
    }
    if (photoSizeDown.length) {
      this.props.attachFiles(photoSizeDown);
      if (this.state.width > 992) {
        this.props.onCloseModalePhoto();
      }
    }
  }
  toMega = (aSize) => {
    aSize = Math.abs(parseInt(aSize, 10));
    var def = [
      [1, "octets"],
      [1024, "ko"],
      [1024 * 1024, "Mo"],
      [1024 * 1024 * 1024, "Go"],
      [1024 * 1024 * 1024 * 1024, "To"],
    ];
    for (var i = 0; i < def.length; i++) {
      if (aSize < def[i][0])
        return (aSize / def[i - 1][0]).toFixed(2) + " " + def[i - 1][1];
    }
  };
  fetchMoreData = () => {
    if (this.state.items.length === this.props.dataPost.files.length) {
      this.setState({ hasMore: false });
      return;
    }
    setTimeout(() => {
      this.setState({
        items: this.state.items.concat(Array.from({ length: 10 })),
      });
    }, 500);
  };
  closeModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.closeModalPost();
    }, 400);
  };
  render() {
     let scrollStyle = {
      maxHeight: 270,
    };
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    const toMega = (aSize) => {
      aSize = Math.abs(parseInt(aSize, 10));
      var def = [
        [1, "octets"],
        [1024, "ko"],
        [1024 * 1024, "Mo"],
        [1024 * 1024 * 1024, "Go"],
        [1024 * 1024 * 1024 * 1024, "To"],
      ];
      for (var i = 0; i < def.length; i++) {
        if (aSize < def[i][0])
          return (aSize / def[i - 1][0]).toFixed(2) + " " + def[i - 1][1];
      }
    };
    const getName = (name) => {
      if (name.length > 20) {
        const lastDot = name.lastIndexOf(".");
        let fileName = name.substring(0, lastDot);
        let newName = name.substring(0, 15);
        const ext = name.substring(lastDot + 1);
        newName = newName + "." + ext;
        return newName;
      } else {
        return name;
      }
    };
    const classes = makeStyles((theme) => ({
      root: {
        "& > *": {
          margin: theme.spacing(1),
        },
      },
      input: {
        display: "none",
      },
    }));
    let url =
      this.props.dataPost.type === "VIDEO" &&
      !_.isEmpty(this.props.dataPost.files)
        ? URL.createObjectURL(this.props.dataPost.files)
        : null;
    const mystyle = {
      minWidth: "100%",
    };
    return (
      <StyleRoot>
        <div
          className="modal show modal-skin"
          id="modalAddMedia"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modalMedia"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content" style={{ top: 140 }}>
              {this.state.openMediaPost ? (
                <MediaPost
                  width={100}
                  height={100}
                  onCloseModalePhoto={this.onCloseModalePhoto}
                />
              ) : null}
              <form onSubmit={this.handleSubmit}>
                <button
                  type="button"
                  onClick={this.closeModal}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close src="img/close.svg" className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title mt-0">Créer un post</h5>
                    <div className="publish-zone">
                      <div className="row d-flex align-items-center justify-content-center">
                        <div className="col-lg-9" style={mystyle}>
                          <div className="new-post d-flex align-items-start">
                            <div className="infos">
                              <div className="user-avatar">
                                <img
                                  src={this.props.lienPhoto}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="post-write">
                              <textarea
                                placeholder="Que souhaitez-vous partager ?"
                                className="form-control"
                                name="postDescription"
                                style={{ minHeight: 150 + "px" }}
                                value={this.state.postDescription}
                                onChange={this.handleChangeDescription}
                              />
                              {!isMobile ? (
                                <div className="search-media btn-gradient">
                                  <a
                                    href="#"
                                    data-toggle="modal"
                                    data-target="#modalAddMedia"
                                    onClick={this.openMediaPost}
                                  >
                                    <span>Ajouter photos / Vidéo</span>
                                  </a>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="list-medias pt-1">
                        {this.props.loading ? (
                          <div className="content p-0">
                            <DotLoader
                              size={100}
                              color={"#ff7d26"}
                              css={override}
                              loading={this.props.loading}
                            />
                          </div>
                        ) : this.props.dataPost.type === "VIDEO" &&
                          this.props.dataPost.files ? (
                          <div className="item-media row mx-0 d-flex align-items-center">
                            <div className="col-md-9 px-0 d-flex align-items-center">
                              <div className="img-media-post">
                                <video width="100%" height="100%" controls>
                                  <source
                                    src={url}
                                    type={this.props.dataPost.files.type}
                                  />
                                  Your browser does not support HTML5 video.
                                </video>
                              </div>
                              <div className="infos-media-post">
                                <p>{getName(this.props.dataPost.files.name)}</p>
                                <p className="text-grey">
                                  {toMega(this.props.dataPost.files.size)}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3 px-0 d-flex align-items-center justify-content-end">
                              <div className={classNames("favori-media")}></div>
                              <a
                                href="#"
                                className="delete-media"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.deleteMedia(
                                    this.props.dataPost.files,
                                    []
                                  );
                                }}
                              ></a>
                            </div>
                          </div>
                        ) : this.props.dataPost.type === "PHOTO" ||
                          this.props.dataPost.type === "PHOTOS" ? (
                          <div id="scrollableDiv" style={{ overflow: "auto" }}>
                            <InfiniteScroll
                              dataLength={this.state.items.length}
                              next={this.fetchMoreData}
                              hasMore={this.state.hasMore}
                              // height={this.state.height}
                              scrollableTarget="scrollableDiv"
                              style={scrollStyle}
                            >
                              {this.props.dataPost.files.map(
                                (element,index) => (
                                  <div
                                    className="item-media row mx-0 d-flex align-items-center"
                                    key={index}
                                  >
                                    <div className="col-md-9 px-0 d-flex align-items-center">
                                      <div className="img-media-post">
                                        <img
                                          src={URL.createObjectURL(element)}
                                          className="img-fluid"
                                        />
                                      </div>
                                      <div className="infos-media-post">
                                        <p>{getName(element.name)}</p>
                                        <p className="text-grey">
                                          {toMega(element.size)}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-3 px-0 d-flex align-items-center justify-content-end">
                                      <div
                                        className={classNames("favori-media")}
                                      >
                                        <input
                                          type="checkbox"
                                          id={"media-favori" + index}
                                          checked={
                                            this.props.indeUrlFavori === index
                                          }
                                          readOnly
                                        />
                                        <label
                                          htmlFor={"media-favori" + index}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.props.addFavori(
                                              element,
                                              index
                                            );
                                          }}
                                        ></label>
                                      </div>
                                      <a
                                        href="#"
                                        className="delete-media"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.deleteMedia(
                                            this.props.dataPost,
                                            element
                                          );
                                        }}
                                      ></a>
                                    </div>
                                  </div>
                                )
                              )}
                            </InfiniteScroll>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </section>

                  <div className="mt-3 d-flex align-items-center justify-content-center">
                    {isMobile ? (
                      <div className={classes.root}>
                        <input
                          className={classes.input}
                          id="contained-button-file"
                          multiple
                          type="file"
                          style={{ display: "none" }}
                          onChange={this.attachFile}
                          //  accept="video/mp4,video/mov,video/quicktime,image/png,image/bmp,image/jpeg"
                        />

                        <div className="input-file-style mr-3">
                          <label
                            htmlFor="contained-button-file"
                            className="m-0 btn-white btn-border btn-label"
                          >
                            <img src={imgWhite} className="img-fluid" alt="" />{" "}
                            Parcourir
                          </label>
                        </div>
                      </div>
                    ) : null}
                    <button type="submit" className="btn-blue px-5">
                      Publier
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
const mapStateToProps = (state) => ({
  dataPost: state.Communaute.data,
  loading: state.Communaute.loading,
  error: state.Communaute.error,
});

export default connect(mapStateToProps, {
  addPostCommunaute,
  uploadPhotos,
  deleteMedia,
  openSnackBar,
  uploadVideo,
  attachFiles,
  attachVideo,
})(ModalPost);

function getExtension(filename) {
  var parts = filename.split(".");
  return parts[parts.length - 1];
}

function isImage(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "jpg":
    case "gif":
    case "bmp":
    case "png":
      //etc
      return true;
  }
  return false;
}

function isVideo(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "m4v":
    case "avi":
    case "mpg":
    case "mp4":
    case "mov":
      // etc
      return true;
  }
  return false;
}
